export var GenericRowDirection;
(function (GenericRowDirection) {
    GenericRowDirection[GenericRowDirection["HORIZONTAL"] = 0] = "HORIZONTAL";
    GenericRowDirection[GenericRowDirection["VERTICAL"] = 1] = "VERTICAL";
})(GenericRowDirection || (GenericRowDirection = {}));
//# sourceMappingURL=interfaces.js.map